

































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';


@Component
export default class InfoColumnContacts extends Vue {
  @Prop() contacts!: any[];

  @Prop() meta!: any;
  // @Prop() icon!: string;
  // @Prop() bg!: string;
}
